import React from "react";
import { Controller } from "react-hook-form";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  Switch,
} from "@mui/material";
import { PIPELINE_FIELD_MAPPING } from "../../utils";

const inputStyle = (hasError) => ({
  width: "100%",
  padding: "16.5px 14px",
  fontSize: "1rem",
  border: hasError ? "1px solid #d32f2f" : "1px solid rgba(0, 0, 0, 0.23)",
  borderRadius: "4px",
  fontFamily: "inherit",
  marginTop: "20px",
});

const PipelineFormFields = ({ control, errors, trigger }) => {
  const fm = PIPELINE_FIELD_MAPPING;

  const handleBlur = async (fieldName) => {
    await trigger(fieldName);
  };

  return (
    <>
      <FormControl
        fullWidth
        error={!!errors[fm.name]}
        className="CustomFormControl"
        style={{ marginBottom: "20px" }}
      >
        <Controller
          name={fm.name}
          control={control}
          render={({ field }) => (
            <>
              <InputLabel shrink>{fm.nameLabel}</InputLabel>
              <input
                {...field}
                type="text"
                maxLength={100}
                onBlur={() => handleBlur(fm.name)}
                placeholder={`Enter ${fm.nameLabel}`}
                style={inputStyle(errors[fm.name])}
              />
            </>
          )}
        />
        {errors[fm.name] && (
          <FormHelperText>{errors[fm.name].message}</FormHelperText>
        )}
      </FormControl>

      <FormControl
        fullWidth
        error={!!errors[fm.description]}
        className="CustomFormControl"
        style={{ marginBottom: "20px" }}
      >
        <Controller
          name={fm.description}
          control={control}
          render={({ field }) => (
            <>
              <InputLabel shrink>{fm.descriptionLabel}</InputLabel>
              <textarea
                {...field}
                maxLength={255}
                onBlur={() => handleBlur(fm.description)}
                placeholder={`Enter ${fm.descriptionLabel}`}
                rows={3}
                style={{ ...inputStyle(errors[fm.description]), resize: "vertical" }}
              />
            </>
          )}
        />
        {errors[fm.description] && (
          <FormHelperText>{errors[fm.description].message}</FormHelperText>
        )}
      </FormControl>

      <FormControl fullWidth style={{ marginBottom: "20px" }}>
        <Controller
          name={fm.isActive}
          control={control}
          render={({ field }) => (
            <FormControlLabel
              label={fm.isActiveLabel}
              control={
                <Switch
                  checked={!!field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                  color="primary"
                />
              }
            />
          )}
        />
      </FormControl>
      <FormControl fullWidth style={{ marginBottom: "20px" }}>
        <Controller
          name={fm.isConsumptionVisible}
          control={control}
          render={({ field }) => (
            <FormControlLabel
              label={fm.isConsumptionVisibleLabel}
              control={
                <Switch
                  checked={!!field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                  color="primary"
                />
              }
            />
          )}
        />
      </FormControl>

      <FormControl fullWidth style={{ marginBottom: "20px" }}>
        <Controller
          name={fm.isStorageVisible}
          control={control}
          render={({ field }) => (
            <FormControlLabel
              label={fm.isStorageVisibleLabel}
              control={
                <Switch
                  checked={!!field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                  color="primary"
                />
              }
            />
          )}
        />
      </FormControl>
    </>
  );
};

export default PipelineFormFields;
